// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__Jxp93","Label":"BuildControl_Label__3a_Pa","Less":"BuildControl_Less__254iK","More":"BuildControl_More__1XWv0"};